import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv } from '@esg/shared';

interface ForwardTokenReviewRequest extends HttpRequestData {
    readonly pathData: {
        readonly saleId?: string;
    };
}

export interface ForwardTokenReviewResponse {
    readonly endPoint?: string;
    readonly url?: number;
}

export const getForwardTokenReview = httpUtil.createHttpRequestMeta<
    ForwardTokenReviewRequest,
    ForwardTokenReviewResponse
>({
    baseUrl: () => getEnv().MANAGEMENT_SERVER,
    method: 'GET',
    path: '/api/v1/forwards/sale/:saleId',
});
